import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FlowFieldDetailsQueryGql: DocumentNode = gql`
query FlowFieldDetailsQuery($flowOutputStepId: ID!, $flowFieldId: ID!) {
  flowOutputSteps(filter: { id: $flowOutputStepId }) {
    outputFields(filter: { id: $flowFieldId }) {
      name
      __typename
      ... on FlowColumnOutputField {
        column {
          id
          name
          table {
            id
            name
          }
        }
      }
      ... on FlowFieldOutputField {
        field {
          id
          name
          datasource {
            ... on PublishedDatasource {
              vizportalUrlId
            }
            name
          }
        }
      }
    }
  }
}
`;
